import { render } from "./AddFundTab.vue?vue&type=template&id=1c52db62&scoped=true"
import script from "./AddFundTab.vue?vue&type=script&lang=js"
export * from "./AddFundTab.vue?vue&type=script&lang=js"

import "./AddFundTab.vue?vue&type=style&index=0&id=1c52db62&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c52db62"]])

export default __exports__